module.exports = __webpack_public_path__ + "static/media/FAQ-cash.2db0edf0.svg";